<script>
    import { dateTextforTimeMS } from "../../scripts/wpn2Model.js";
    import schemaData from "../../Stores/wpn2SchemaStore.js"

    export let item;
    export let showTitle = false;
</script>

<div id="date-cell">
    {#if item.entity == "Activity"}    
        {(showTitle) ? 
        $schemaData['keysList'].find(x => x.key === "data_date").title + ": " + dateTextforTimeMS(item.data_date, true) : 
        dateTextforTimeMS(item.data_date, true)}
    <!-- {(showTitle) ? infoForKeyName("data_date", $schemaData).title + ": " + dateTextforTimeMS(item.data_date, true) : dateTextforTimeMS(item.data_date, true)} -->
    {:else}
        {(showTitle) ? 
        $schemaData['keysList'].find(x => x.key === "last_updated").title + ": " + dateTextforTimeMS(item.last_updated, true) : 
        dateTextforTimeMS(item.last_updated, true)}
        <!-- {(showTitle) ? infoForKeyName("last_updated", $schemaData).title + ": " + dateTextforTimeMS(item.last_updated, true) : dateTextforTimeMS(item.last_updated, true)} -->
    {/if}
</div>
